namespace RecordShield.Models {
    export enum PaymentStatus {
        Pending = 1,
        PaymentAdded = 2,
        Confirmed = 3,
        Declined = 4
    }
    Serenity.Decorators.registerEnum(PaymentStatus, 'RecordShield.Models.PaymentStatus');
}
